<template>
    <!-- 台账表单，客户管理和续费管理都要 -->
    <div>
        <a-table size="small" rowClassName="tableRowClass" :loading="state.loading" :pagination="pagination"
            :dataSource="dataSource" @change="onChange" :columns="columns">
            <template #bodyCell="{ column, record, index, text }">
                <template v-if="column.dataIndex === 'full_name'">
                    <div class="mv-1x">
                        <a-popover trigger="click" v-model:open="record.isShowCompany"
                            overlayClassName="customer-options-popover">
                            <template #content>
                                <p @click="handleDoubleNameClick(record.tyc_url)">跳转到天眼查</p>
                                <p @click="handleDoubleNameClick(record.qcc_url)">跳转到企查查</p>
                            </template>
                            <div style="width: 100%"></div>
                        </a-popover>
                        <span class="mr-1x pointer"
                            :style="record.status === 5 ? { textDecorationLine: 'line-through' } : {}" @click="
                                (e) => {
                                    record.isShowCompany = false
                                    handleNameClick(e, record.full_name)
                                }
                            " @dblclick="
                                () => {
                                    record.isShowCompany = true
                                }
                            " v-html="record.full_name"></span><a @click="onViewLogClick(record, 1)">日志</a>
                    </div>
                </template>

                <template v-if="column.dataIndex === 'reason'">
                    <a-tag color="black" v-html="record.reason"></a-tag>
                    <p>{{ record.idcard_name }} {{ record.created_at }}</p>
                </template>
                <template v-if="column.dataIndex === 'current_status'">
                    <a-tag :color="record.exception_flag == 1 ? 'green' : record.exception_flag == 2 ? 'black' : 'red'">
                        {{ record.exception_flag_name }}</a-tag>
                    <p>{{ record.exception_flag_time }}</p>
                </template>
                <template v-if="column.dataIndex === 'seller'">
                    <div v-hasUser="[record.seller_id, record.ludan_id]">
                        <p class="mb-x">代理商：{{ record.seller ? record.seller : '-' }}</p>
                        <p class="mb-x">
                            <a-popover placement="left" :overlayInnerStyle="{
                                padding: '25px'
                            }">
                                <template #content>
                                    <div
                                        style="font-size: 16px; font-weight: 550; border-bottom: 1px dotted #ccc; padding-bottom: 8px">
                                        渠道详细情况：</div>
                                    <div style="width: 450px; line-height: 26px">
                                        <a-row>
                                            <a-col :span="10" style="text-align: right">工商预留手机号码：</a-col>
                                            <a-col :span="14">{{ record.registration_mobile }}<a
                                                    @click="handleCopyClick(record.registration_mobile)" class="ml-1x">
                                                    <CopyOutlined />
                                                </a></a-col>
                                        </a-row>
                                        <a-row>
                                            <a-col :span="10" style="text-align: right">续费联系人手机号码：</a-col>
                                            <a-col :span="14">{{ record.xftel }}<a
                                                    @click="handleCopyClick(record.xftel)" class="ml-1x">
                                                    <CopyOutlined />
                                                </a></a-col>
                                        </a-row>
                                        <a-row>
                                            <a-col :span="10" style="text-align: right">财务公司名称：</a-col>
                                            <a-col :span="14">{{ record.finance_company_name }}</a-col>
                                        </a-row>
                                        <a-row>
                                            <a-col :span="10" style="text-align: right">财务公司统一社会信用代码：</a-col>
                                            <a-col :span="14">{{ record.finance_social_credit_code }}</a-col>
                                        </a-row>
                                        <a-row>
                                            <a-col :span="10" style="text-align: right">财务公司对接人姓名：</a-col>
                                            <a-col :span="14">{{ record.finance_contact_name }}</a-col>
                                        </a-row>
                                        <a-row>
                                            <a-col :span="10" style="text-align: right">财务公司对接人其他号码：</a-col>
                                            <a-col :span="14">{{ record.finance_contact_phone }}</a-col>
                                        </a-row>
                                        <a-row>
                                            <a-col :span="10" style="text-align: right">财务公司对接人微信昵称：</a-col>
                                            <a-col :span="14"><a-avatar size="small" :src="record.xf_person?.headimgurl"
                                                    v-if="!!record.finance_contact_wechat_nickname">
                                                    <template #icon>
                                                        <UserOutlined />
                                                    </template> </a-avatar>{{
                                                        record.finance_contact_wechat_nickname }}</a-col>
                                        </a-row>
                                        <a-row>
                                            <a-col :span="10" style="text-align: right">财务公司对接人微信号：</a-col>
                                            <a-col :span="14">{{ record.finance_contact_wechat_account
                                            }}<a v-if="!!record.finance_contact_wechat_account"
                                                    @click="handleCopyClick(record.finance_contact_wechat_account)"
                                                    class="ml-1x">
                                                    <CopyOutlined />
                                                </a></a-col>
                                        </a-row>
                                        <a-row>
                                            <a-col :span="10" style="text-align: right">备注：</a-col>
                                            <a-col :span="14">{{ record.remark }}</a-col>
                                        </a-row>
                                    </div>
                                </template>
                                <a-avatar size="small" :src="record.xf_person?.headimgurl">
                                    <template #icon>
                                        <UserOutlined />
                                    </template>
                                </a-avatar>
                            </a-popover>
                            {{ record.nickname }}
                            <span v-if="record.nickname">
                                <a type="primary" style="margin-left: 10px" @click="onViewLogClick(record, 4)"> 发消息
                                </a>
                            </span>
                            <span v-else><a-image :width="20" src="https://hncs.cskaiyela.com/wxewm.jpg" /></span>
                        </p>
                    </div>
                    <span>{{ record.created_at2 }}</span><a @click="handleCopyClick(record.xftel)" class="ml-1x"
                        v-hasUser="[record.seller_id, record.ludan_id]">
                        <CopyOutlined />
                    </a>
                </template>
            </template>
        </a-table>
        <!-- 查看日志 -->
        <view-log :logTabsKey="state.logTabsKey" v-if="state.visibleLog" :tableColumnsData="state.tableColumnsData"
            @cancel="viewLogCancel"></view-log>
    </div>
</template>
<script lang="ts" setup>
import { UserOutlined, CopyOutlined, PlusOutlined, DownOutlined, UpOutlined } from '@ant-design/icons-vue'
import { unref, ref, reactive, h, onMounted, computed, onActivated } from 'vue'
import type { PaginationProps } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { message, Modal, Table } from 'ant-design-vue'
import ViewLog from './ViewLog.vue'
const props = defineProps({
    queryParam: {
        type: Object,
        default: () => null
    }
})
interface Istate {
    loading: boolean,
    visibleLog: boolean,
    tableColumnsData: any,
    logTabsKey: number
}
const state = reactive<Istate>({
    loading: false,
    visibleLog: false,
    tableColumnsData: {},
    // 进入日志 还是进入状态
    logTabsKey: 1,

})
const pagination = reactive<PaginationProps>({
    pageSize: 100,
    pageSizeOptions: ['10', '20', '40', '50', '60', '100', '200', '500'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
let dataSource = ref([])
const columns = [
    {
        title: '公司名称',
        dataIndex: 'full_name',
        key: 'full_name'
    },
    {
        title: '地址',
        dataIndex: 'full_address',
        key: 'full_address'
    },
    {
        title: '操作动作',
        dataIndex: 'reason',
        key: 'reason'
    },
    {
        title: '当前状态',
        dataIndex: 'current_status',
        key: 'current_status'
    },

    {
        title: '代理商',
        dataIndex: 'seller',
        key: 'seller'
    }
]
onMounted(() => {
    //加载数据是外面主动调用loadData
})
// 表格分页查询
const onChange = (val, filters) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    if (filters.status) {
        props.queryParam.order_status_list = filters.status
    }
    loadData()
}
// 获取台账数据
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/customerTaizhangList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize }, props.queryParam)
    }
    baseService(requestParam)
        .then((res) => {
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item) => ({ ...item, isShowOptions: false }))
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('客户列表查询失败,请联系管理员')
            }
        }).finally(() => {
            state.loading = false
        })
}
// 复制
const handleCopyClick = (val) => {
    if (!val) {
        message.error('手机号不存在')
        return
    }
    var input = document.createElement('textarea')
    //将input的值设置为需要复制的内容
    eval('input.value' + '="' + val + '"')
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功!')
    //移除input标签
    document.body.removeChild(input)
}
// 跳转天眼查
const handleDoubleNameClick = (url) => {
    window.open(url)
}
// 复制名称
const handleNameClick = (e, name) => {
    if (e.detail == 1) {
        var input = document.createElement('input')
        //将input的值设置为需要复制的内容
        input.value = name
        //添加input标签
        document.body.appendChild(input)
        //选中input标签
        input.select()
        //执行复制
        document.execCommand('copy')
        //成功提示信息
        message.success('复制成功，尝试双击有惊喜！')
        //移除input标签
        document.body.removeChild(input)
    }
}
// 查询日志
const onViewLogClick = (record, val) => {
    record.from = 0
    state.visibleLog = true
    state.tableColumnsData = { ...record }
    state.logTabsKey = val
}
const viewLogCancel = (isRefresh) => {
    if (isRefresh) {
        loadData()
    }
    state.visibleLog = false
}
defineExpose({
    loadData
})
</script>
